var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKnowledgeBase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1649_20586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.068 197.32C153.556 197.32 197.728 153.148 197.728 98.6599C197.728 44.1715 153.556 0 99.068 0C44.5797 0 0.408173 44.1715 0.408173 98.6599C0.408173 153.148 44.5797 197.32 99.068 197.32Z",
    fill: "#C1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.397 72.2989C115.397 72.2989 117.417 62.0254 117.572 60.4872C117.727 58.9491 118.019 54.5814 116.803 52.8711C115.586 51.1607 116.257 48.5723 116.114 47.4359C116.039 46.8447 116.556 44.9852 113.388 42.9994C110.22 41.0135 110.139 38.2644 106.437 37.9659C101.387 37.5584 103.401 36.0203 100.009 35.917C97.8226 35.8538 96.5829 36.9328 95.148 37.1854C93.4492 37.4838 91.5781 36.5942 89.4718 37.1739C86.2003 38.0692 87.6581 39.4409 82.8485 41.0307C79.3188 42.1958 81.9073 44.6121 79.2959 47.2924C76.6902 49.9727 77.0977 51.2641 77.1666 51.8552C77.2986 52.9916 77.3904 56.5041 76.6099 58.4555C75.8293 60.4069 76.6845 61.9106 77.1953 63.3684C77.7061 64.8262 81.2014 73.5558 81.2014 73.5558L84.1227 76.701C83.2159 71.6388 82.0737 65.1074 82.0737 65.1074C82.0737 65.1074 81.5342 61.4687 81.9302 59.2418C82.3263 57.0149 82.4296 56.2114 83.807 54.4609C85.1845 52.7104 85.0525 51.0747 87.9451 50.4031C89.3053 50.0875 90.7861 50.1678 91.8594 49.835C93.0646 49.4619 93.8624 48.6813 95.5383 48.4805L96.9387 48.314C98.6089 48.1131 99.5731 48.6871 100.83 48.7617C101.949 48.8306 103.367 48.4001 104.767 48.3886C107.734 48.3657 107.993 49.9842 109.743 51.3559C111.494 52.7276 111.522 53.336 112.429 55.4079C113.336 57.4798 113.893 61.6581 113.893 61.6581",
    fill: "#191A20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.397 72.2989C115.397 72.2989 117.417 62.0254 117.572 60.4872C117.727 58.9491 118.019 54.5814 116.803 52.8711C115.586 51.1607 116.257 48.5723 116.114 47.4359C116.039 46.8447 116.556 44.9852 113.388 42.9994C110.22 41.0135 110.139 38.2644 106.437 37.9659C101.387 37.5584 103.401 36.0203 100.009 35.917C97.8226 35.8538 96.5829 36.9328 95.148 37.1854C93.4492 37.4838 91.5781 36.5942 89.4718 37.1739C86.2003 38.0692 87.6581 39.4409 82.8485 41.0307C79.3188 42.1958 81.9073 44.6121 79.2959 47.2924C76.6902 49.9727 77.0977 51.2641 77.1666 51.8552C77.2986 52.9916 77.3904 56.5041 76.6099 58.4555C75.8293 60.4069 76.6845 61.9106 77.1953 63.3684C77.7061 64.8262 81.2014 73.5558 81.2014 73.5558L84.1227 76.701C83.2159 71.6388 82.0737 65.1074 82.0737 65.1074C82.0737 65.1074 81.5342 61.4687 81.9302 59.2418C82.3263 57.0149 82.4296 56.2114 83.807 54.4609C85.1845 52.7104 85.0525 51.0747 87.9451 50.4031C89.3053 50.0875 90.7861 50.1678 91.8594 49.835C93.0646 49.4619 93.8624 48.6813 95.5383 48.4805L96.9387 48.314C98.6089 48.1131 99.5731 48.6871 100.83 48.7617C101.949 48.8306 103.367 48.4001 104.767 48.3886C107.734 48.3657 107.993 49.9842 109.743 51.3559C111.494 52.7276 111.522 53.336 112.429 55.4079C113.336 57.4798 113.893 61.6581 113.893 61.6581",
    stroke: "#191A20",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0056 102.436L93.1794 89.2358C93.1794 89.2358 96.0778 91.7209 98.3276 91.6406C100.577 91.5602 108.486 88.6791 108.486 88.6791L113.939 102.695C113.939 102.695 111.832 111.223 101.702 111.034C91.5724 110.845 90.4647 104.669 89.9998 102.442L90.0056 102.436Z",
    fill: "white",
    stroke: "#1E1F24",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.513 66.8523C114.513 66.8523 114.759 63.4373 117.055 63.6267C118.863 63.776 119.236 65.7618 118.886 68.2928C118.283 72.6892 117.348 77.5275 114.605 75.8803",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.513 66.8523C114.513 66.8523 114.759 63.4373 117.055 63.6267C118.863 63.776 119.236 65.7618 118.886 68.2928C118.283 72.6892 117.348 77.5275 114.605 75.8803",
    stroke: "#1E1F24",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7108 69.8424C82.7108 69.8424 81.8269 67.1105 79.6345 67.8049C78.8138 68.069 77.3904 69.963 78.7564 73.0909C80.4552 76.9994 82.4755 82.1591 84.754 79.9093",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7108 69.8424C82.7108 69.8424 81.8269 67.1105 79.6345 67.8049C78.8138 68.069 77.3904 69.963 78.7564 73.0909C80.4552 76.9994 82.4755 82.1591 84.754 79.9093",
    stroke: "#1E1F24",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.887 61.6639C113.887 61.6639 113.554 58.0021 112.647 55.9302C111.741 53.8583 111.488 52.7391 109.738 51.3617C107.987 49.9842 107.729 48.3657 104.761 48.3944C103.361 48.4059 101.943 48.8364 100.824 48.7675C99.5674 48.6871 98.6031 48.1189 96.933 48.3198L95.5326 48.4863C93.8624 48.6871 93.0589 49.4677 91.8536 49.8408C90.7804 50.1736 89.2996 50.0876 87.9394 50.409C85.0467 51.0862 85.1787 52.7219 83.8013 54.4667C82.4238 56.2115 82.3205 57.0207 81.9245 59.2476C81.5285 61.4745 82.068 65.1132 82.068 65.1132C82.068 65.1132 83.543 77.2807 84.7425 79.9151C85.9421 82.5495 87.2793 86.9516 96.0606 93.0812C99.8027 95.6869 104.945 94.5046 107.614 91.5718C113.79 84.7878 114.128 80.6842 114.599 75.886C115.087 70.8698 113.881 61.6754 113.881 61.6754",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.887 61.6639C113.887 61.6639 113.554 58.0021 112.647 55.9302C111.741 53.8583 111.488 52.7391 109.738 51.3617C107.987 49.9842 107.729 48.3657 104.761 48.3944C103.361 48.4059 101.943 48.8364 100.824 48.7675C99.5674 48.6871 98.6031 48.1189 96.933 48.3198L95.5326 48.4863C93.8624 48.6871 93.0589 49.4677 91.8536 49.8408C90.7804 50.1736 89.2996 50.0876 87.9394 50.409C85.0467 51.0862 85.1787 52.7219 83.8013 54.4667C82.4238 56.2115 82.3205 57.0207 81.9245 59.2476C81.5285 61.4745 82.068 65.1132 82.068 65.1132C82.068 65.1132 83.543 77.2807 84.7425 79.9151C85.9421 82.5495 87.2793 86.9516 96.0606 93.0812C99.8027 95.6869 104.945 94.5046 107.614 91.5718C113.79 84.7878 114.128 80.6842 114.599 75.886C115.087 70.8698 113.881 61.6754 113.881 61.6754",
    stroke: "#1E1F24",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4438 62.6051C98.0062 67.7189 98.5917 73.1311 99.0336 76.1558C99.1426 76.9191 99.8371 77.4529 100.606 77.3668L102.5 77.1602",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4438 62.6051C98.0062 67.7189 98.5917 73.1311 99.0336 76.1558C99.1426 76.9191 99.8371 77.4529 100.606 77.3668L102.5 77.1602",
    stroke: "#1E1F24",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9168 67.2827C92.4398 67.2827 92.8638 66.8587 92.8638 66.3357C92.8638 65.8127 92.4398 65.3887 91.9168 65.3887C91.3938 65.3887 90.9698 65.8127 90.9698 66.3357C90.9698 66.8587 91.3938 67.2827 91.9168 67.2827Z",
    fill: "#191A20",
    stroke: "#191A20",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.67 65.7561C105.193 65.7561 105.617 65.3321 105.617 64.8091C105.617 64.286 105.193 63.8621 104.67 63.8621C104.147 63.8621 103.723 64.286 103.723 64.8091C103.723 65.3321 104.147 65.7561 104.67 65.7561Z",
    fill: "#191A20",
    stroke: "#191A20",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1599 85.7807C98.9188 84.8338 99.4067 83.8581 100.245 83.5998C101.083 83.3415 101.966 83.904 102.207 84.8452C102.449 85.7865 101.961 86.7679 101.123 87.0262C100.285 87.2845 99.4009 86.722 99.1599 85.7807Z",
    fill: "#1F2025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0056 102.436C90.0056 102.436 66.4741 104.795 59.5295 109.909C52.5848 115.023 58.3185 185.629 56.7631 199.782H144.225C144.225 199.782 152.031 119.947 148.283 115.838C144.535 111.728 138.526 103.458 113.933 102.695C113.933 102.695 111.924 107.435 105.938 108.956C99.0967 110.695 93.4607 109.599 89.9998 102.436H90.0056Z",
    fill: "#135AA0",
    stroke: "#135AA0",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6412 98.2754C40.6412 95.1302 43.1952 92.5762 46.3404 92.5762C49.4856 92.5762 52.0396 95.1302 52.0396 98.2754V105.042",
    stroke: "#1F2025",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9072 112.819L60.3789 132.086L74.6642 127.449L56.1662 103.079",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9072 112.819L60.3789 132.086L74.6642 127.449L56.1662 103.079",
    stroke: "#1F2025",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3569 194.548H19.9048L22.4818 146.107L22.1432 152.495L5.1489 140.666C5.1489 140.666 5.99832 139.306 14.4983 127.408C22.9984 115.511 25.0358 116.194 29.966 115.511C34.8961 114.833 37.5477 115.511 37.5477 115.511C37.5477 115.511 41.5021 124.51 51.4312 124.906C62.468 124.309 65.3148 115.511 65.3148 115.511C65.3148 115.511 67.9664 114.833 72.8965 115.511C77.8266 116.188 79.8641 115.511 88.3641 127.408C96.8641 139.306 97.7135 140.666 97.7135 140.666L80.725 152.616L80.3806 146.107L82.9576 194.548H55.3742H55.3569Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5362 115.516L45.5943 111.958L56.9353 111.252L65.309 115.516",
    stroke: "#1F2025",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9457 99.1535C48.0163 98.7116 50.2719 98.1319 54.9839 97.9598C58.3012 97.8392 58.1118 101.145 56.6139 101.857C56.6139 101.857 59.782 103.297 56.9927 105.203C56.9927 105.203 59.6213 107.091 56.8549 108.859C56.8549 108.859 58.3472 111.149 55.753 111.958C53.1588 112.773 47.9818 113.336 47.2529 113.456C47.2529 113.456 45.9042 113.766 45.1982 110.718C44.4923 107.671 42.8508 99.452 44.94 99.1535H44.9457Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.334 98.2754C144.334 95.1302 146.888 92.5762 150.034 92.5762C153.179 92.5762 155.733 95.1302 155.733 98.2754V105.042",
    stroke: "#1F2025",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.604 112.819L145.132 132.086L130.853 127.449L149.351 103.079",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.604 112.819L145.132 132.086L130.853 127.449L149.351 103.079",
    stroke: "#1F2025",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.16 194.548H185.612L183.035 146.107L183.374 152.495L200.368 140.666C200.368 140.666 199.519 139.306 191.019 127.408C182.519 115.511 180.481 116.194 175.551 115.511C170.621 114.828 167.969 115.511 167.969 115.511C167.969 115.511 164.015 124.51 154.086 124.906C143.049 124.309 140.202 115.511 140.202 115.511C140.202 115.511 137.551 114.833 132.62 115.511C127.69 116.188 125.653 115.511 117.153 127.408C108.653 139.306 107.803 140.666 107.803 140.666L124.792 152.616L125.136 146.107L122.559 194.548H150.143H150.16Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.975 115.516L159.917 111.958L148.582 111.252L140.208 115.516",
    stroke: "#1F2025",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.565 99.1535C157.495 98.7116 155.239 98.1319 150.527 97.9598C147.21 97.8392 147.399 101.145 148.897 101.857C148.897 101.857 145.729 103.297 148.518 105.203C148.518 105.203 145.89 107.091 148.656 108.859C148.656 108.859 147.164 111.149 149.758 111.958C152.352 112.773 157.529 113.336 158.258 113.456C158.258 113.456 159.607 113.766 160.313 110.718C161.002 107.768 162.66 99.452 160.571 99.1535H160.565Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2367 158.596L48.8255 165.191L61.8424 152.174",
    stroke: "#135AA0",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.069 165.191L162.086 152.174",
    stroke: "#135AA0",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.086 165.191L149.069 152.174",
    stroke: "#135AA0",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1649_20586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200.184,
    height: 200,
    fill: "white",
    transform: "translate(0.408173)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeBase);
export default __webpack_public_path__ + "static/media/knowledge_base.abed4033bbf307bf4c1ec9a314fc0794.svg";
export { ForwardRef as ReactComponent };